import React from 'react'
import FileButton from '../FileButton'
import ViewButton from '../ViewButton'
import AlertDismissible from '../AlertDismissible'

const StudentValidateButtons = ({ file, setFile, slug, nssRef = null }) => {

  return (
    <div>
      { 
        !file || file.tiene_documento === false? <FileButton setFile={setFile} slug={slug} nssRef={nssRef} />
          : file.aceptado === null ?
             (
               <>
                <FileButton setFile={setFile} slug={slug} nssRef={nssRef}/>{' '}
                <ViewButton slug={slug} path={`/alumnos/inscripcion/documentos/${slug}/ver`} />{' '}
               </>
             )
          : file.aceptado === false ? 
          (
            <>
             <FileButton setFile={setFile} slug={slug} nssRef={nssRef}/>{' '}
             <ViewButton slug={slug} path={`/alumnos/inscripcion/documentos/${slug}/ver`}/>{' '}
             {/* <AlertDismissible message={file.observaciones} dismiss={false}/> */}
            </>
          )
          : file.aceptado === true && file.pendiente ?
            <>
              <FileButton setFile={setFile} slug={slug} nssRef={nssRef}/>{' '}
              <ViewButton slug={slug} path={`/alumnos/inscripcion/documentos/${slug}/ver`} />{' '}
            </>
            
          : <ViewButton slug={slug} path={`/alumnos/inscripcion/documentos/${slug}/ver`} />
      }
    </div>
  )
}

export default StudentValidateButtons